export default __webpack_public_path__ + "static/media/step-four.c1eb660b.png";